import {MapViewerConfiguration} from "../../config/map-viewer-configuration";
import { DataTransporter } from "../data-transporter";

export class AuthenticationStore {
  mapViewerConfig: MapViewerConfiguration;
  dataTransporter: DataTransporter;
  user: User | undefined;


  constructor(mapViewerConfig: MapViewerConfiguration, dataTransporter: DataTransporter) {
    this.mapViewerConfig = mapViewerConfig;
    this.dataTransporter = dataTransporter;
    this.user = undefined;
  }

  async login(loginCredentials: LoginCredentials): Promise<User> {
    const result = await this.dataTransporter.post(`${this.mapViewerConfig.api_base_url}/login`, loginCredentials);
    const user: User = result.data;
    this.user = user;
    return user;
  }

  async authenticate(): Promise<User> {
    const result = await this.dataTransporter.get(`${this.mapViewerConfig.api_base_url}/login`);
    const user: User = result.data;
    this.user = user;
    return user;
  }

  async logout() {
    await this.dataTransporter.get(`${this.mapViewerConfig.api_base_url}/logout`);
    this.user = undefined;
  }

  loggedIn(): boolean {
    return this.user !== undefined;
  }

  authorized(): boolean {
    return (
        this.user !== undefined &&
        (this.user.roleIds.includes(1) || this.user.roleIds.includes(2)) &&
        this.user.enabled
    );
  }
}

type LoginCredentials = {
  email: string;
  password: string;
};

export type User = {
  id: number;
  firstName: string;
  lastName: string;
  emailLogin: string;
  email: string;
  phone: string;
  enabled: boolean;
  roleIds: number[];
};


